<template>
   <input 
      v-if="type!=='textarea'"
      :type="type"
      :placeholder="placeholder"
      v-bind="$props"
      class='input'
      :class="classes"
      v-model="hcValue"
   />
   <textarea
      v-else
      :placeholder="placeholder"
      v-bind="$props"
      class='input'
      :class="classes"
      v-model="hcValue"
   />
</template>

<script>
export default {
   name: 'Input',
   props: {
      type: {
         type: String,
         default: 'text',
         validator: value => ['text', 'email', 'number', 'textarea', 'password'].includes(value),
      },
      value: {
         required: true,
         validator: value => (
            value==null ||
            typeof(value) === "string" ||
            typeof(value) === "number"
         ),
      },
      placeholder: {
         type: String,
      },
      color: {
         type: String,
         default: 'primary',
         validator: value => ['primary', 'success', 'info', 'danger'].includes(value),
      },
      size: {
         type: String,
         default: 'medium',
         validator: value => ["large", "medium", "small"].includes(value),
      },
   },
   computed: {
      hcValue: {
         get()
         {
            return this.value;
         },
         set(newValue, oldValue)
         {
            if (newValue!==oldValue) this.$emit('input', newValue);
         }
      },
      classes()
      {
         return [this.color, this.size];
      }
   }
}
</script>

<style lang="scss" scoped>
@mixin setSize($size, $padding)
{
}

@mixin setTheme($color)
{
   @if $color == $primary-color
   {
      $color: lighten($color, 20%);
   }
   @else
   {
      $color: darken($color, 10%);
   }
   &:focus {
      border: 1px solid rgba($color, 0.9);
      box-shadow: inset 0 1px 1px $light-color,
         0 0 6px rgba($color, 0.4);
   }
}

::placeholder {
   font-family:  $primary-font;
}
.input {
   font-family: $primary-font;
   background-color: $light-color;
   border: 1px solid darken($light-color, 15%);
   border-radius: $border-radius;
   color: darken($font-color, 15%);
   display: block;
   margin: 0.2rem 0;
   width: 100%;
   outline: none;
   transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
   padding: 0.4em 0.8em;
   
   &.small {
      font-size: 0.8em;
   }
   &.medium {
      font-size: 0.9em;
   }
   &.large {
      font-size: 1em;
   }

   &.primary { @include setTheme($primary-color); }
   &.secondary { @include setTheme($secondary-color); }
   &.success { @include setTheme($success-color); }
   &.info { @include setTheme($info-color); }
   &.light { @include setTheme($light-color); }
   &.dark { @include setTheme($dark-color); }
   &.danger {
      border: 1px solid rgba($danger-color, 0.6);
      box-shadow: inset 0 1px 1px $light-color, 0 0 6px rgba($danger-color, 0.2);
      @include setTheme($danger-color);
   }
}

</style>